const LIFECYCLE_STAGES = [
  { key: 'paid', label: 'Paid' },
  { key: 'queued', label: 'Queued' },
  { key: 'printing', label: 'Printing' },
  { key: 'post_processing', label: 'Finishing' },
  { key: 'packed', label: 'Packed' },
  { key: 'shipped', label: 'Shipped' },
  { key: 'delivered', label: 'Delivered' },
] as const;

const TERMINAL_STATUSES = new Set(['cancelled', 'rejected', 'refunded', 'failed']);

interface OrderProgressProps {
  readonly status: string;
}

export const OrderProgress = ({ status }: OrderProgressProps) => {
  if (TERMINAL_STATUSES.has(status)) {
    return null;
  }

  const currentIndex = LIFECYCLE_STAGES.findIndex((s) => s.key === status);

  return (
    <div
      className="order-progress-stepper"
      style={{ display: 'flex', alignItems: 'center', gap: '0', overflowX: 'auto', padding: 'var(--space-2) 0' }}
    >
      {LIFECYCLE_STAGES.map((stage, i) => {
        const isComplete = i < currentIndex;
        const isCurrent = i === currentIndex;

        return (
          <div
            key={stage.key}
            className="flex items-center"
            style={{ flex: i < LIFECYCLE_STAGES.length - 1 ? 1 : 0 }}
          >
            <div className="flex flex-col items-center" style={{ minWidth: '40px' }}>
              <div
                className="step-circle"
                style={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 'var(--text-xs)',
                  fontWeight: 'var(--font-weight-semibold)',
                  backgroundColor: isComplete
                    ? 'var(--color-success-500)'
                    : isCurrent
                      ? 'var(--color-primary-600)'
                      : 'var(--bg-surface-sunken)',
                  color: isComplete || isCurrent ? 'var(--color-white)' : 'var(--text-tertiary)',
                  transition: 'all 0.2s',
                  flexShrink: 0,
                }}
              >
                {isComplete ? (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  i + 1
                )}
              </div>
              <span
                className="step-label"
                style={{
                  marginTop: '4px',
                  fontSize: '10px',
                  color: isCurrent ? 'var(--text-primary)' : 'var(--text-tertiary)',
                  fontWeight: isCurrent ? 'var(--font-weight-semibold)' : 'var(--font-weight-normal)',
                  whiteSpace: 'nowrap',
                  textAlign: 'center',
                }}
              >
                {stage.label}
              </span>
            </div>
            {i < LIFECYCLE_STAGES.length - 1 && (
              <div
                className="step-connector"
                style={{
                  flex: 1,
                  height: '2px',
                  backgroundColor: isComplete ? 'var(--color-success-500)' : 'var(--border-default)',
                  minWidth: '8px',
                  marginTop: '-16px',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
